var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(0.000000, 1.000000)",
    fill: "#006F44",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,16 L15.5,16 C15.7761424,16 16,15.7761424 16,15.5 C16,15.2238576 15.7761424,15 15.5,15 L0.5,15 C0.223857625,15 0,15.2238576 0,15.5 C0,15.7761424 0.223857625,16 0.5,16 Z",
    id: "Line-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-2",
    points: "10 2.29289322 9.29289322 3 12 5.70710678 12.7071068 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1830629,-0.153075492 C12.3910896,-0.323565055 12.6967143,-0.298941029 12.8747623,-0.0973456144 L15.1595116,2.48956845 C15.3482359,2.70325204 15.3203711,3.03123838 15.0983039,3.21002229 L3.69653335,12.3894657 C3.60768322,12.4609979 3.49704542,12.5 3.38297872,12.5 L1,12.5 C0.723857625,12.5 0.5,12.2761424 0.5,12 L0.5,9.65853659 C0.5,9.50871406 0.567184723,9.36678716 0.683062885,9.27181852 L12.1830629,-0.153075492 Z M12.4442322,0.92581323 L1.5,9.89522437 L1.5,11.5 L3.20671861,11.5 L14.0635452,2.75928518 L12.4442322,0.92581323 Z",
    id: "Line-2-Copy-2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6a44eda8a54e0a8f54131850168633a4.svg";
export { ForwardRef as ReactComponent };